import { render, staticRenderFns } from "./PartitionPermissionsPage.vue?vue&type=template&id=173620f4&"
import script from "./PartitionPermissionsPage.vue?vue&type=script&lang=js&"
export * from "./PartitionPermissionsPage.vue?vue&type=script&lang=js&"
import style0 from "./PartitionPermissionsPage.vue?vue&type=style&index=0&id=173620f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports